import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const ProviderAuthContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ProviderAuthProvider = ({ children }) => {
  const [provider, setProvider] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem('provider_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const storedToken = localStorage.getItem('provider_token');
      if (storedToken) {
        try {
          const response = await axios.get(`${API}/providers/me`, {
            headers: { Authorization: `Bearer ${storedToken}` }
          });
          setProvider(response.data);
          setToken(storedToken);
        } catch (error) {
          localStorage.removeItem('provider_token');
          setToken(null);
          setProvider(null);
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = useCallback(async (email, password) => {
    const response = await axios.post(`${API}/providers/login`, { email, password });
    const { token: newToken, provider: providerData } = response.data;
    localStorage.setItem('provider_token', newToken);
    setToken(newToken);
    setProvider(providerData);
    return providerData;
  }, []);

  const register = useCallback(async (payload) => {
    const response = await axios.post(`${API}/providers/register`, payload);
    const { token: newToken, provider: providerData } = response.data;
    localStorage.setItem('provider_token', newToken);
    setToken(newToken);
    setProvider(providerData);
    return providerData;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('provider_token');
    setToken(null);
    setProvider(null);
  }, []);

  const value = {
    provider,
    token,
    loading,
    login,
    register,
    logout
  };

  return (
    <ProviderAuthContext.Provider value={value}>
      {children}
    </ProviderAuthContext.Provider>
  );
};

export const useProviderAuth = () => {
  const context = useContext(ProviderAuthContext);
  if (!context) {
    throw new Error('useProviderAuth must be used within a ProviderAuthProvider');
  }
  return context;
};